// StoreCashSearch.tsx
import { useRef, useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Badge } from "primereact/badge";
import { Dialog } from "primereact/dialog";

import DeliveryCashService from "../../services/deliverycash/deliverycashservice";
import IncomingCashRequestsDialog from "./incomingCashRequestDialog";

interface StoreCashSearchProps {
  onSearch: (payload: any) => void;
  setLoading: (loading: boolean) => void;
  refreshData: () => void;
  onReset: () => void;
}
interface UserOption {
  userID: number;
  name: string;
  primaryContactNbr: string;
  displayText: string;
}

const StoreCashSearch: React.FC<StoreCashSearchProps> = ({ onSearch, setLoading,refreshData,onReset }) => {
  const toast = useRef<Toast>(null);
  const [users, setUsers] = useState<UserOption[]>([]);
  const [selectedUser, setSelectedUser] = useState<UserOption   | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [showRequestsDialog, setShowRequestsDialog] = useState(false);
  const [pendingRequestCount, setPendingRequestCount] = useState<number>(0);


  useEffect(() => {
    fetchPendingRequests();
  }, []);

  const fetchPendingRequests = async () => {
    try {
      const requests = await DeliveryCashService.gethandoverrequests();
      setPendingRequestCount(requests.length);
    } catch (error) {
      console.error("Failed to fetch pending requests", error);
    }
  };

useEffect(() => {
    const fetchUsers = async () => {
      try {
        const userList: UserOption[] = await DeliveryCashService.GetuserlistSearch();

        const mappedUsers = userList.map((user) => ({
          ...user,
          displayText: `${user.name} - ${user.primaryContactNbr}`,
        }));

        setUsers(mappedUsers);
      } catch (error) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load users.",
        });
      }
    };

    fetchUsers();
  }, []);

  const formatToSQLDateTime = (date: Date) =>
    date.toLocaleString("sv-SE").replace(" ", "T");

  const handleSearch = () => {
    if (!startDate || !endDate) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select both Start Date and End Date."
      });
      return;
    }

    const payload = {
      userId: selectedUser?.userID,
      startDate: formatToSQLDateTime(new Date(startDate.setHours(0, 0, 0, 0))),
      endDate: formatToSQLDateTime(new Date(endDate.setHours(23, 59, 59, 999)))
    };

    onSearch(payload);
  };

  const handleReset = () => {
    setSelectedUser(null);
    setStartDate(null);
    setEndDate(null);
    onReset();
  };

  return (
    <div className="card border-noround p-3 w-full">
      <Toast ref={toast} />

      <div className="grid">
        {/* <div className="col-12 md:col-2">
          <Dropdown
            value={selectedUser}
            onChange={(e: DropdownChangeEvent) => setSelectedUser(e.value)}
            options={users}
            optionLabel="name"
            placeholder="Select User"
            className="w-full"
            filter
          />
        </div> */}

        <div className="col-6 md:col-2">
          <Calendar
            value={startDate}
            onChange={(e) => setStartDate(e.value as Date)}
            showButtonBar
            dateFormat="dd/mm/yy"
            placeholder="Start Date"
            className="w-full"
            readOnlyInput
          />
        </div>

        <div className="col-6 md:col-2">
          <Calendar
            value={endDate}
            onChange={(e) => setEndDate(e.value as Date)}
            showButtonBar
            dateFormat="dd/mm/yy"
            placeholder="End Date"
            className="w-full"
            readOnlyInput
          />
        </div>

        <div className="col-6 md:col-1">
          <Button label="Filter" onClick={handleSearch} severity="success" className="w-full" />
        </div>

        <div className="col-6 md:col-1">
          <Button label="Reset" onClick={handleReset} severity="secondary" className="w-full" text raised />
        </div>
 <div className="col-6 md:col-2" /> 
       <div className="col-12 md:col-4 flex justify-content-end align-items-center">
  <div style={{ position: "relative" }}>
    <Button
      icon="pi pi-bell"
      label="Requests"
      onClick={() => setShowRequestsDialog(true)}
      severity="secondary"
    />
    {pendingRequestCount > 0 && (
      <Badge
        value={pendingRequestCount}
        severity="danger"
        style={{
          position: "absolute",
          top: "-8px",
          right: "-8px"
        }}
      />
    )}
  </div>
</div>
      </div>

      <Dialog
        visible={showRequestsDialog}
        onHide={() => setShowRequestsDialog(false)}
        header="Incoming Requests"
        modal
        style={{ width: '50vw' }}
      >
        <IncomingCashRequestsDialog
          onHide={() => setShowRequestsDialog(false)}
          setLoading={setLoading}
          visible={showRequestsDialog}
          refreshRequestsCount={fetchPendingRequests}
          refreshData={refreshData}
          toastRef={toast} 
  //          refreshCashTable={() => {
  //   if (startDate && endDate) {
  //     const payload = {
  //       userId: selectedUser?.userID,
  //       startDate: formatToSQLDateTime(new Date(startDate.setHours(0, 0, 0, 0))),
  //       endDate: formatToSQLDateTime(new Date(endDate.setHours(23, 59, 59, 999)))
  //     };
  //     onSearch(payload); // <-- Refetch data using current filter
  //   }
  // }}
        />
      </Dialog>
    </div>
  );
};

export default StoreCashSearch;
